/* eslint-disable no-unused-vars */
// pages/auth/callback.js

import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS, GETTING_STARTED, HOME, JWTToken, SESSION_STORAGE_KEY, TOKEN_DATA_TYPE } from "../../vars";
import { handleErrorMessage, handlePostHogCustomEvent, setLocalStorageData, setSessionStorage } from "../../utils/util";
import apiClient from "../../service/apiService";
import { auth0Service } from "../../service/auth0service";
import LoadingScreen from "../../components/loadingScreen/LoadingScreen";
import SpecificButton from "../../components/specificButton/SpecificButton";
import { UserDetailsContext } from "../../context/userDetails";

export default function AuthCallback() {
	const [error, setError] = useState(null);
	const navigate = useNavigate();
	const { setEmail, shopDomain } = useContext(UserDetailsContext);

	// eslint-disable-next-line no-unused-vars
	const handleInviteCodeVerification = async ({ inviteCode, email }) => {
		if (!inviteCode) {
			return;
		}
		try {
			await apiClient.post(API_ENDPOINTS.invite.userInvitesAccept, { inviteCode }, { headerToken: TOKEN_DATA_TYPE.ACCESS });
			handlePostHogCustomEvent(`${shopDomain}/invite-verification`, { email, isVerified: true, inviteCode });
		} catch (err) {
			console.log(err, "while code verify");
			handlePostHogCustomEvent(`${shopDomain}/invite-verification`, { email, isVerified: false, inviteCode });
		}
	};

	const handleCallback = async () => {
		let paramsEmail = null;
		let inviteCode = null;

		try {
			const searchParams = new URLSearchParams(window.location.search);
			const code = searchParams.get("code");
			const state = searchParams.get("state"); // might be null

			if (code) {
				if (state) {
					// Normal Auth0 flow (SDK-managed)
					const { appState } = await auth0Service.handleRedirectCallback();
					const accessToken = await auth0Service.silentLogin();
					console.log("AppState:", appState);
					console.log("Access Token:", accessToken);
					setLocalStorageData(JWTToken, accessToken);
					setSessionStorage(SESSION_STORAGE_KEY.IS_VERIFIED, true);
					const user = await auth0Service.getUser();
					console.log("User:", user);
					setSessionStorage(SESSION_STORAGE_KEY.EMAIL, user?.email || "");
					setEmail(user?.email || "");
					paramsEmail = user?.email || appState?.email || "";
					inviteCode = appState?.inviteCode || "";
					const isIdntfy = appState?.isIdntfy || "";
					handlePostHogCustomEvent(`${shopDomain}/verification`, { email: paramsEmail, isVerified: true });
					if (inviteCode) {
						await handleInviteCodeVerification({ inviteCode, email: paramsEmail });
					}
					if (appState?.email && !isIdntfy) {
						navigate(GETTING_STARTED);
					} else {
						navigate(`${HOME}?silent_auth=true`);
					}
				} else {
					const isAuth = await auth0Service.isAuthenticated();
					console.log("Is Authenticated:", isAuth);
					await auth0Service.loginWithRedirectOnly({
						partnerConnection: "swan-staging-testing",
					});
				}
			}
		} catch (err) {
			setError(handleErrorMessage(err));
			console.error("Auth callback error:", err);
			handlePostHogCustomEvent(`${shopDomain}/verification`, { data: JSON.stringify(err), email: paramsEmail, isVerified: false });
		}
	};

	useEffect(() => {
		handleCallback();
	}, []);
	if (error)
		return (
			<div className="h-screen w-screen flex justify-center items-center">
				<div>
					<p>❌ Error: {error} </p>
					<div className="flex justify-center mt-4">
						<SpecificButton buttonFunc={() => navigate(GETTING_STARTED)} btnSecondary buttonText="Back" />
					</div>
				</div>
			</div>
		);
	return (
		<div className="h-screen w-screen flex justify-center items-center">
			<LoadingScreen loaderType="black" />
		</div>
	);
}
